import type { Client2TrackedTranslation, Values } from '@ps/web-core-intl';
import { InfoIcon, Translation } from '@ps/web-shared-components';
import { StarsInfo } from '@ps/web-shared-ui';
import React from 'react';

import { CollapsiblePanel } from '@swf/first';

import { TXTWCL_Just_so_you_know } from './InfoBox.messages.json';
import { collapseTitle, info, infoContent, infoHeader, infoIcon } from './InfoBox.scss';

interface Props {
  children: React.ReactNode;
  title?: Client2TrackedTranslation;
  collapsible?: boolean;
  values?: Values;
}

export const InfoBox: React.FC<Props> = ({
  collapsible = false,
  values,
  children,
  title = TXTWCL_Just_so_you_know
}) => {
  const body = collapsible ? (
    <CollapsiblePanel
      label={title}
      icon="info"
      className={collapseTitle}
      {...(values ? { values } : {})}
      blue
      endIconFloatRight
    >
      <div className={infoContent}>{children}</div>
    </CollapsiblePanel>
  ) : (
    <>
      <div className={infoHeader}>
        <InfoIcon className={infoIcon} />
      </div>
      <div>
        <Translation tagName="b" {...title} {...(values ? { values } : {})} />
        <br />
        {children}
      </div>
    </>
  );

  return <StarsInfo className={info}>{body}</StarsInfo>;
};

export default InfoBox;
